export default {
  wallet: {
    title: '지갑',
    balance: '잔액',
    deposit: '입금',
    withdraw: '출금',
    rollover: '롤오버',
    transaction: '거래 내역',
    myBet: '내 베팅',
    totalBalance: '총 잔액',
    withdrawableBalance: '출금 가능 잔액',
    bonus: '보너스',
    bonusBalance: '보너스 잔액',
    cashBalance: '현금 잔액',
    withdrawable: '출금 가능',
    depositNow: '지금 입금',
    getBonus: '보너스 받기',
    bonusGames: '보너스 게임',
    playNow: '지금 플레이',
    fiatAccount: '법정화폐 계정',
    cash: '현금',
    rules: '규칙',
    ruleQ1: '1. 보너스란 무엇인가요?',
    ruleA1: '보너스는 활동 참여 후 플랫폼에서 지급하는 보상으로, 지정된 보너스 게임에서 베팅에 사용할 수 있습니다.',
    ruleQ2: '2. 보너스는 어떻게 사용하나요?',
    ruleA2: '보너스는 현금 지갑 잔액이 소진된 후에만 베팅에 사용할 수 있습니다. 보너스는 베팅 조건을 충족해야 현금 지갑으로 전환할 수 있습니다.',
    ruleQ3: '3. 어떤 게임이 보너스 베팅을 지원하나요?',
    ruleA3: '대부분의 슬롯 게임이 보너스 베팅을 지원합니다. 자세한 게임 목록은 보너스 게임 페이지를 참고하세요.',
    ruleQ4: '4. 보너스를 현금 지갑으로 전환하는 데 제한이 있나요?',
    ruleA4: '보너스 베팅의 베팅 조건을 충족하면 리워드 센터에서 원래 보너스를 현금 지갑으로 전환할 수 있습니다. 남은 보너스 수익은 보너스 지갑으로 반환되며 베팅 조건이 다시 계산됩니다.',
    ruleQ5: '5. 보너스 수익을 현금 지갑으로 전환하는 데 제한이 있나요?',
    ruleA5: '보너스 수익은 15배의 베팅 조건을 충족해야 합니다. 현금 지갑으로 전환할 수 있는 최대 보너스 수익은 USDT5,000.00이며, 1회 최대 베팅 금액은 USDT1,000.00입니다.',
    ruleQ6: '6. 베팅 조건은 어떻게 계산되나요?',
    ruleA6: '슬롯 게임: 베팅 금액 = 베팅 조건. 기타 게임: 베팅 금액 = 수익의 절댓값(베팅 금액까지)',
    select: '선택',
    currency: '통화',
    loading: '로딩 중...',
    noMoreData: '더 이상 데이터가 없습니다',
    noData: '데이터 없음',
    colType: '유형',
    colTime: '시간',
    colStatus: '상태',
    colAmount: '금액',
    colBalance: '잔액',
    allType: '모든 유형',
    allStats: '모든 상태',
    colWallet: '지갑',
    colCurrent: '현재',
    colRequired: '필요',
    colStats: '상태',
    totalVaultBalance: '금고 총 잔액',
    amount: '금액',
    availableBalance: '사용 가능 잔액:',
    max: '최대',
    depositInVault: '금고에 입금',
    depositCurrency: '입금 통화',
    currencyBalance: '통화별 잔액',
    history: '내역',
    vaultRules: '금고 규칙',
    vaultRule1: '금고는 거래 수수료나 블록체인 지연 걱정 없이 자금을 안전하게 보관하는 공간입니다. 금고는 본인 전용 디지털 지갑이나 은행 예금 계좌처럼 작동합니다. 2FA 덕분에 매우 안전하며, 자금을 보호하기 위한 강화된 보안 조치를 적용할 수 있습니다.',
    vaultRule2: '금고의 입금과 출금은 2FA로 보호되며 예치자가 언제든지 이용할 수 있습니다.',
    vaultRule3: '금고 내 자금은 예치자 외에는 누구도 손댈 수 없습니다. 당신의 것이며 언제나 안전하게 사용할 수 있습니다!',
    selectTime: '기간 선택',
    colGame: '게임',
    colBet: '베팅',
    colWin: '당첨',
    colProfit: '수익',
    sports: '스포츠',
    allGames: '모든 게임',
    today: '오늘',
    yesterday: '어제',
    last3Days: '최근 3일',
    last7Days: '최근 7일',
    last15Days: '최근 15일',
    last30Days: '최근 30일',
  },
};
